import React from 'react';
import MenuItemAnchor from './MenuItemAnchor';
import useSyncPromise from '../../utils/react/useSyncPromise';
import fetchUser from '../../utils/gaia/fetchUser';
import gettext from '../../utils/django/gettext';

function useIsVisible() {
    const [user] = useSyncPromise(fetchUser());
    return user && (!user.hasSubscription && user.isAuthenticated);
}

const sharedProps = {
    href: '/membership/',
    children: gettext('Membership'),
};

function Toolbar(props: React.HTMLProps<HTMLAnchorElement>) {
    if (!useIsVisible()) return null;
    return <a {...props} {...sharedProps} />;
}

function HamburgerMenu(props: React.HTMLProps<HTMLAnchorElement>) {
    if (!useIsVisible()) return null;
    return <MenuItemAnchor {...props} {...sharedProps} />;
}

export default {Toolbar, HamburgerMenu};
